<script setup lang="ts">
import { computed, unref } from "vue";
import { Spinner } from "~/components/clarity-ui/Spinner";
import useCommonLabels from "~/composables/useCommonLabels";
import useMarketSetup from "~/composables/useMarketSetup";
import { imagePath } from "~/utils/helper/magnolia";

export interface LoadingElementProps {
  overlay?: boolean;
  small?: boolean;
}

const { overlay = false, small = false } = defineProps<LoadingElementProps>();

const { marketSetup } = useMarketSetup();
const setupImagePath = imagePath(unref(marketSetup).loadingImage);

const { getLabelByPath } = useCommonLabels();
const loadingAriaLabel = computed(() => getLabelByPath("BWF/shared/loadingAriaLabel"));
</script>

<template>
  <div
    v-if="setupImagePath"
    class="inset-0 flex h-full w-full items-center justify-center"
    :class="{ 'absolute z-10 bg-black/40': overlay, relative: !overlay }"
  >
    <div class="relative aspect-square" :class="[small ? 'w-20' : 'w-20 md:w-32']">
      <img
        loading="lazy"
        class="absolute inset-0 h-full w-full object-contain"
        :src="setupImagePath"
        :alt="loadingAriaLabel"
      />
    </div>
  </div>
  <div
    v-else
    class="flex h-full w-full items-center justify-center"
    :class="{
      'absolute inset-0 z-10 bg-black/40': overlay,
      relative: !overlay,
    }"
  >
    <Spinner :aria-label="loadingAriaLabel" :size="small ? 'small' : 'medium'" />
  </div>
</template>
